/* eslint-disable */
import store from '@/store/index'

class Orientation {
  constructor () {
    this.handleOrientationChange()
    window.addEventListener('orientationchange', this.handleOrientationChange)
  }

  handleOrientationChange () {
    if (window?.screen?.orientation?.type) {
      const orientation = window.screen.orientation.type
      store.state.widget.orientation = (orientation === 'portrait-primary') ? 'portrait' : 'landscape'
    } else {
      var mql = window.matchMedia('(orientation: portrait)')
      store.state.widget.orientation = mql.matches ? 'portrait' : 'landscape'
    }
  }
}

export default new Orientation()
